import React from 'react';
import PropTYpes from 'prop-types';
import RegisterForm from './RegisterForm';

function RegisterContainer(props) {
  const { isOpen, onClose } = props;
  return (
    <RegisterForm isOpen={isOpen} onClose={onClose} />
  );
}

RegisterContainer.propTypes = {
  isOpen: PropTYpes.bool.isRequired,
  onClose: PropTYpes.func.isRequired,
};
export default RegisterContainer;
